import { Legend } from "src/components";
import { Color } from "src/elements";
import { lightenDarkenColor } from "src/utils";

export const StoresListLegend = () => (
  <Legend
    legends={[
      { label: "Store Approved", icon: { name: "checkmarkCircle" } },
      {
        label: "Multiple Stores Approved",
        icon: { name: "alert", color: Color.red },
      },
    ]}
  />
);

export const StoresGridLegend = () => (
  <Legend
    legends={[
      {
        label: "Template",
        background: Color.sand50,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        borderColor: lightenDarkenColor(Color.sand50, -20),
      },
      {
        label: "Store Unapproved",
        background: Color.sand50,
        borderColor: Color.textMain,
      },
      {
        label: "Store Approved",
        background: Color.greenSmoke,
        borderColor: Color.primary,
      },
      {
        label: "Multiple Stores Approved",
        background: Color.redDisabled,
        borderColor: Color.red,
      },
    ]}
  />
);
